// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Signup-m_aD43ebuaT_SzfbQfFARN {
    display: flex;
    flex-direction: column;
    width: 100%;
}

.Signup-m_aD43ebuaT_SzfbQfFARN > * {
    margin-bottom: 1rem;
}

.Signup-m_qKhVacpRncvZHyNgjrVq {
  text-align: center;
}

.Signup-m_PyTKEr4sAy01m2r5lDaT {
  outline: var(--error) solid 2px;
}

.Signup-m_bHO52BPOpzQThPziq4k_ {
  color: var(--error-foreground);
  background-color: var(--error-background);
  border: 1px solid var(--error-foreground);
  padding: .5rem;
  font-size: .8rem;
}

.Signup-m_IZQRzz0e1obfXWUHwx6l {
  color: var(--success-foreground);
  background-color: var(--success-background);
  border: 1px solid var(--success-foreground);
  padding: .5rem;
  font-size: .8rem;
}

.Signup-m_UemmLFdzIVanZjaRI2UE h2 {
  margin-top: 2rem;
}

.Signup-m_aD43ebuaT_SzfbQfFARN button:disabled {
  cursor: not-allowed;
  filter: brightness(0.8);
}

.Signup-m_aD43ebuaT_SzfbQfFARN button:disabled:hover {
  background-color: var(--pps-blue);
}`, "",{"version":3,"sources":["webpack://./client/login/Signup/Signup.m.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,sBAAsB;IACtB,WAAW;AACf;;AAEA;IACI,mBAAmB;AACvB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,8BAA8B;EAC9B,yCAAyC;EACzC,yCAAyC;EACzC,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,gCAAgC;EAChC,2CAA2C;EAC3C,2CAA2C;EAC3C,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,iCAAiC;AACnC","sourcesContent":[".formContainer {\n    display: flex;\n    flex-direction: column;\n    width: 100%;\n}\n\n.formContainer > * {\n    margin-bottom: 1rem;\n}\n\n.heading {\n  text-align: center;\n}\n\n.invalid {\n  outline: var(--error) solid 2px;\n}\n\n.error {\n  color: var(--error-foreground);\n  background-color: var(--error-background);\n  border: 1px solid var(--error-foreground);\n  padding: .5rem;\n  font-size: .8rem;\n}\n\n.valid {\n  color: var(--success-foreground);\n  background-color: var(--success-background);\n  border: 1px solid var(--success-foreground);\n  padding: .5rem;\n  font-size: .8rem;\n}\n\n.invalidSignupCode h2 {\n  margin-top: 2rem;\n}\n\n.formContainer button:disabled {\n  cursor: not-allowed;\n  filter: brightness(0.8);\n}\n\n.formContainer button:disabled:hover {\n  background-color: var(--pps-blue);\n}"],"sourceRoot":""}]);
// Exports
export var formContainer = `Signup-m_aD43ebuaT_SzfbQfFARN`;
export var heading = `Signup-m_qKhVacpRncvZHyNgjrVq`;
export var invalid = `Signup-m_PyTKEr4sAy01m2r5lDaT`;
export var error = `Signup-m_bHO52BPOpzQThPziq4k_`;
export var valid = `Signup-m_IZQRzz0e1obfXWUHwx6l`;
export var invalidSignupCode = `Signup-m_UemmLFdzIVanZjaRI2UE`;
export default ___CSS_LOADER_EXPORT___;
